import { textBlock } from '@/uiPrimitives/typography/text';

const headingBaseStyle = {
	fontWeight: 'bold',
	capLineHeight: 'tight',
	fontVariantNumeric: 'lining-nums',
	textWrap: 'balance',
} as const satisfies Parameters<typeof textBlock>[0];

export const h1CSS = textBlock({
	...headingBaseStyle,
	capSize: '3 | h1',
});

export const h2CSS = textBlock({
	...headingBaseStyle,
	capSize: '2 | h2',
});

export const h3CSS = textBlock({
	...headingBaseStyle,
	capSize: '1 | h3',
});

export const h4CSS = textBlock({
	...headingBaseStyle,
	capSize: '0 | p',
});
